import type { CSSProperties } from 'react'

export type PieChartSlice = {
  /** Relative weight of the slice. */
  value: number
  /** CSS color or design-system token. */
  color: string
  /** Optional accessible / legend name. */
  label?: string
}

export const PIE_CHART_DEFAULT_SIZE = 240

/**
 * Default slices matching Figma (clockwise from 12 o’clock):
 * blue-500 105°, blue-300 75°, blue-700 60°, blue-600 60°, blue-400 60°.
 */
export const PIE_CHART_DEFAULT_SLICES: PieChartSlice[] = [
  { value: 7, color: 'var(--ds-blue-500)', label: 'Segment A' },
  { value: 5, color: 'var(--ds-blue-300)', label: 'Segment B' },
  { value: 4, color: 'var(--ds-blue-700)', label: 'Segment C' },
  { value: 4, color: 'var(--ds-blue-600)', label: 'Segment D' },
  { value: 4, color: 'var(--ds-blue-400)', label: 'Segment E' },
]

export type PieChartProps = {
  /** Pie slices. Defaults to the Figma blue-scale demo set. */
  slices?: PieChartSlice[]
  /** Diameter in px. Defaults to 240. */
  size?: number
  className?: string
  style?: CSSProperties
  'aria-label'?: string
}
